import { combineReducers } from 'redux';

import theBasicsReducer from './TheBasics/reducer';
import whereILiveReducer from './WhereILive/reducer';

export default combineReducers({
  the_basics: theBasicsReducer,
  where_i_live: whereILiveReducer,
});
